module.exports = __webpack_public_path__ + "img/BF.118a01ac.svg";